import React, { memo } from 'react';

import CustomSelect from '../../../components/Inputs/CustomSelect/CustomSelect';
import { FieldContainer } from './styles';
import { AccountSettingsProps } from './types';

const AccountSettings: React.FC<AccountSettingsProps> = ({
  label,
  language,
  languages,
  handleLanguageChange,
  handleSaveLanguage,
}) => {
  return (
    <FieldContainer>
      <CustomSelect
        label={label}
        value={language}
        options={languages}
        onChange={handleLanguageChange}
        onSave={handleSaveLanguage}
        isEditInput={true}
        variant="language"
      />
    </FieldContainer>
  );
};

export default memo(AccountSettings);
